<script setup>
import { useDesktopUpdater } from '@/composables/useDesktopUpdater.js';
defineProps({ collapsed: Boolean });
const { state, install } = useDesktopUpdater();
</script>

<template>
    <div v-if="state.status === 'ready' || state.status === 'installing'" class="desktop-update" :class="{ 'desktop-update--collapsed': collapsed }">
        <button type="button" class="desktop-update__button" :disabled="state.status === 'installing'"
            :title="`Update Corecry to ${state.version}`" aria-label="Update & Restart" @click="install">
            <i class="pi" :class="state.status === 'installing' ? 'pi-spin pi-spinner' : 'pi-refresh'" aria-hidden="true"></i>
            <span v-if="!collapsed">{{ state.status === 'installing' ? 'Updating…' : 'Update & Restart' }}</span>
        </button>
    </div>
</template>

<style scoped lang="scss">
.desktop-update { padding: 0.5rem 0.75rem 0; flex-shrink: 0; }
.desktop-update__button {
    --theme-text: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    height: 39px;
    border: 0;
    border-radius: 19.5px;
    background: #38bdf8;
    color: #fff;
    font-size: 0.9375rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.desktop-update__button:hover { background: #0ea5e9; }
.desktop-update__button:focus-visible { outline: 2px solid var(--blue-400, #60a5fa); outline-offset: 3px; }
.desktop-update__button:disabled { cursor: wait; opacity: 0.8; }
.desktop-update--collapsed .desktop-update__button { width: 39px; }
</style>
